module.exports = __webpack_public_path__ + "static/media/freadom_school_logo.e40d3be3.png";